"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _getMarketingLinkItems = function _getMarketingLinkItems() {
  var links = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return links.map(function (_ref) {
    var content = _ref.content,
        url = _ref.url,
        _ref$additionalClassN = _ref.additionalClassName,
        additionalClassName = _ref$additionalClassN === void 0 ? '' : _ref$additionalClassN,
        linkProps = _objectWithoutProperties(_ref, ["content", "url", "additionalClassName"]);

    var className = (0, _classnames2.default)('eds-global-footer__link', _defineProperty({}, additionalClassName, additionalClassName));
    return _react.default.createElement("li", {
      key: content
    }, _react.default.createElement("a", _extends({
      href: url
    }, linkProps, {
      className: className
    }), content));
  });
};

var _getMarketingLinks = function _getMarketingLinks(linkTypes) {
  return linkTypes.map(function (_ref2) {
    var title = _ref2.title,
        links = _ref2.links;
    return _react.default.createElement("div", {
      key: title,
      className: "eds-g-cell eds-g-cell-3-12 eds-l-pad-left-6 eds-l-pad-top-4"
    }, _react.default.createElement("h3", {
      className: "eds-l-pad-vert-2"
    }, title), _react.default.createElement("ul", {
      className: "eds-l-pad-vert-2 eds-l-mar-all-0 eds-l-pad-hor-0"
    }, _getMarketingLinkItems(links)));
  });
};

var MarketingSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MarketingSection, _React$Component);

  function MarketingSection() {
    _classCallCheck(this, MarketingSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(MarketingSection).apply(this, arguments));
  }

  _createClass(MarketingSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          localeInfo = _this$props.localeInfo,
          serverUrl = _this$props.serverUrl,
          popularSearches = _this$props.popularSearches,
          eventsToPlan = _this$props.eventsToPlan,
          thirdFooterColumn = _this$props.thirdFooterColumn,
          thirdFooterColumnName = _this$props.thirdFooterColumnName;

      var marketingLinks = _getMarketingLinks((0, _utils.getMainSections)(serverUrl, localeInfo, popularSearches, eventsToPlan, thirdFooterColumn, thirdFooterColumnName));

      return _react.default.createElement("div", {
        className: "eds-bg-color--grey-900 eds-hide-sw eds-hide-sm eds-hide-sn"
      }, marketingLinks);
    }
  }]);

  return MarketingSection;
}(_react.default.Component);

exports.default = MarketingSection;

_defineProperty(MarketingSection, "propTypes", {
  serverUrl: _propTypes.default.string.isRequired,
  localeInfo: _constants.LOCALE_INFO_SHAPE_PROP_TYPE.isRequired,
  popularSearches: _constants.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  eventsToPlan: _constants.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumn: _constants.LINKS_DATA_SHAPE_PROP_TYPE.isRequired,
  thirdFooterColumnName: _propTypes.default.string.isRequired
});
//# sourceMappingURL=MarketingSection.js.map